import React from "react"
import _ from "lodash"
import { localizeNum } from "data/lib/numbers"

const InputTypeAtRest = (props: {rowData: object, _field: string}) => {
  let record = props.rowData
  let state = _.get(record, "lineitemdetail.state")
  let amtType = _.get(record, "amttype") === "Per Mo" ? "Mo" : "Yr"
  let displayValue = ""
  let amt = localizeNum(_.get(record, "amt"), 2) || " - "

  switch(true) {
    case state === "basic":
      displayValue = `Amount: ${amt}/${amtType}`
      break
    case state === "amtArea":
      displayValue = `Amt/Area: ${amt}/${amtType}`
      break
    case state === "percentEGR":
      displayValue = `% EGR: ${amt}%`
      break
    case state === "percentLineItem":
      displayValue = `% Line Item`
      break
    case state === "percentTenantRevenue":
      displayValue = `% Tenant Revenue`
      break
    case state === "detailed":
      displayValue = `Detailed`
      break
    case state === "detailedPerArea":
      displayValue = `Detailed Per Area`
      break
    case state === "detailedPercentLineItem":
      displayValue = `Detailed % Of Line Item`
      break
    case state === "prop13Tax":
      displayValue = `Prop 13 Tax`
      break
  }

  return <span>{displayValue}</span>
}

export default InputTypeAtRest
